import { useMutation } from 'react-query'
import { showConfirmAlert, showError } from '../../../../../../../_metronic/helpers'
import { deleteSelectedFuncionario } from '../../core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListView } from '../../core/ListViewProvider'
import { TableBulkDangerButton, TableSelectionBar, useToast } from '../../../../../../components'

const FuncionariosListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  // Antes invalidava a chave USERS_LIST, que não é a desta lista: a tela não recarregava.
  const deleteSelectedItems = useMutation(() => deleteSelectedFuncionario(selected), {
    onSuccess: () => {
      showToast({
        variant: 'success',
        title: count === 1 ? '1 funcionário removido.' : `${count} funcionários removidos.`,
      })
      clearSelected()
      refetch()
    },
    onError: showError,
  })

  const askRemove = async () => {
    const confirmed = await showConfirmAlert({
      title: count === 1 ? 'Remover 1 funcionário?' : `Remover ${count} funcionários?`,
      text: 'Os funcionários selecionados serão excluídos. Essa ação não pode ser desfeita. Se quiser apenas suspender o acesso, prefira inativar.',
      confirmButtonText: count === 1 ? 'Remover funcionário' : `Remover ${count} funcionários`,
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await deleteSelectedItems.mutateAsync()
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <TableBulkDangerButton onClick={askRemove} disabled={deleteSelectedItems.isLoading}>
        {count === 1 ? 'Remover selecionado' : 'Remover selecionados'}
      </TableBulkDangerButton>
    </TableSelectionBar>
  )
}

export { FuncionariosListGrouping }
